module.exports = __webpack_public_path__ + "static/david-sewell-2f972c4674f9ff9e0556f1544625a8c4.png";